/* eslint-disable */
import Vue from 'vue'
import Firebase from 'firebase'
import VueFire from 'vuefire'
require('firebase/firestore')

Vue.use(VueFire)

let config = {
  apiKey: __FB_API_KEY__,
  authDomain: __FB_AUTH_DOMAIN__,
  databaseURL: __FB_DATABASE_URL__,
  projectId: __FB_PROJECT_ID__,
  storageBucket: __FB_STORAGE_BUCKET__,
  messagingSenderId: __FB_MESSAGING_SENDER_ID__
}

const firebaseApp = Firebase.initializeApp(config)

export default firebaseApp


// WEBPACK FOOTER //
// ./src/firebaseApp.js